import { render, staticRenderFns } from "./EstablishmentYearSettingEdit.vue?vue&type=template&id=89e81806&scoped=true&"
import script from "./EstablishmentYearSettingEdit.vue?vue&type=script&lang=js&"
export * from "./EstablishmentYearSettingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e81806",
  null
  
)

export default component.exports